import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'nospace'
})
export class NoSpacePipe implements PipeTransform{

    transform(value: string, args?: any){
        if (!value)
            return null;
        return value.replace(/\s/g, "");
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Pipes/nospace.pipe.ts